import { useEffect, useRef } from 'react';
import styles from './style.module.css'

export default function ConfirmModal({
    title,
    subTitle,
    confirmText,
    cancelText,
    onAction,
    onClose,
}){
    const mainRef=useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
          if (mainRef.current && !mainRef.current.contains(event.target)) {
            onClose();
          }
        }
        if (mainRef.current) {
          document.addEventListener("mousedown", handleClickOutside);
          document.addEventListener("keydown", handleInputKeyDown);
        }
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
          document.removeEventListener("keydown", handleInputKeyDown);
        };
    }, []);

    const handleConfirm=()=>{
        onAction();
    }

    const handleInputKeyDown=(e)=>{
        if(e.key ==='Enter'){
            onAction();
        }
        else if(e.key ==='Escape'){
            onClose();
        }
    }

    return(
        <div className={styles['wrap']}>
            <div className={styles['main']} ref={mainRef}>
                <div className={styles['header']}>
                    <div className={styles['header-icon']}>
                        <span className={styles['header-icon-background']}></span>
                        <span className={styles['header-icon-svg']}></span>
                    </div>
                    <span className={styles['header-title']}>{title}</span>
                    {/* <span className={styles['header-close']} onClick={onClose}>X</span> */}
                </div>
                <div className={styles['body']}>
                    <span className={styles['body-text']}>{subTitle}</span>
                </div>
                <div className={styles['footer']}>
                    <div onClick={handleConfirm}>{confirmText}</div>
                </div>
            </div>
        </div>
    )
}

